import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, switchMap, take, throwError } from 'rxjs';

import { ErrorType } from '../../enums/error-type.enum';
import { PaywallService } from '../services/paywall.service';

export const paywallInterceptor: HttpInterceptorFn = (req, next) => {
  const paywall = inject(PaywallService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.error?.errorType !== ErrorType.ProSubscriptionRequired) {
        return throwError(() => error);
      }

      return paywall.load().pipe(
        take(1),
        switchMap(() => {
          const tier = paywall.currentTier();
          if (tier && tier !== 'FREE') return next(req);

          router.navigate(['/subscription/upgrade']);
          return throwError(() => error);
        })
      );
    })
  );
};
